import React                        from 'react';
import { WithStyle }                from 'rewire-ui';
import { isNullOrUndefinedOrEmpty } from 'rewire-common';
import classNames                   from 'classnames';
import { Theme }                    from '@material-ui/core/styles';
import FlowLogoFullWhite            from '../images/flow-logo-full-white.svg';
import FlowLogoFullDark             from '../images/flow-logo-full-dark.svg';
import { withStyles }               from '../utility/styles';

const logoMap = new Map<string, any>([
  ['white', FlowLogoFullWhite],
  ['dark',  FlowLogoFullDark],
]);

const styles = (_theme: Theme) => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  flowLogoContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  before: {
    marginRight: '0.38em',
  },
  after: {
    marginLeft: '0.38em',
  },
  smallFlowLogo: {
    width: '55px',
    marginTop: '4px',
  },
  mediumFlowLogo: {
    width: '95px',
    marginTop: '10px',
  },
  largeFlowLogo: {
    width: '200px',
    marginTop: '20px',
  },
  noText: {
    marginTop: '0px',
  },
});

interface ITitleWithFlowLogoProps {
  beforeText?: string;
  afterText?:  string;
  variant?:    'white' | 'dark';
  size?:       'small' | 'medium' | 'large';
  classes?:    any;
}

type TitleWithFlowLogoProps = WithStyle<ReturnType<typeof styles>, ITitleWithFlowLogoProps>;

class TitleWithFlowLogo extends React.PureComponent<TitleWithFlowLogoProps> {
  constructor(props: TitleWithFlowLogoProps) {
    super(props);
  }

  render() {
    const {classes, beforeText, afterText, variant, size} = this.props;

    const before: JSX.Element | undefined = !isNullOrUndefinedOrEmpty(beforeText) ? <div className={classes.before}>{beforeText}</div> : undefined;
    const after:  JSX.Element | undefined = !isNullOrUndefinedOrEmpty(afterText ) ? <div className={classes.after}>{afterText}</div>   : undefined;
    const hasText                         = !!before || !!after;
    const logo                            = logoMap.get(`${variant || 'dark'}`);
    const logoClass                       = classNames(classes[`${size || 'small'}FlowLogo`], !hasText ? classes.noText : undefined);
    return (
      <div className={classes.titleContainer}>
        {before}<div className={classes.flowLogoContainer}><img className={logoClass} src={logo} alt='Flow' /></div>{after}
      </div>
    );
  }
}

export default withStyles<ITitleWithFlowLogoProps>(styles, TitleWithFlowLogo);
